import React from 'react';
import styled from 'styled-components';
import { FlexCenterAligned } from '../../styled/common';
import { PlaceholderBlock } from '../../styled/placeholders.styled';

const HeaderPlaceholderWrapper = styled(FlexCenterAligned)`
  padding: 2.1875vw 4.6875vw;
  height: 17.1875vw;
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

export const HeaderPlaceholder = () => (
  <HeaderPlaceholderWrapper>
    <PlaceholderBlock
      width="7.6875vw"
      height="8.1875vw"
      margin="0 3.2vw 0 0"
      borderRadius="4px"
    />
    <PlaceholderBlock width="31.5625vw" height="9.1875vw" borderRadius="4px" />
    <PlaceholderBlock
      width="36vw"
      height="10.9375vw"
      borderRadius="4px"
      margin="0 0 0 auto"
    />
  </HeaderPlaceholderWrapper>
);
